import { BookOpen, Star, Trophy, Lightbulb } from "lucide-react";

const MASKY_LOGO = "https://customer-assets.emergentagent.com/job_1abea0ec-cded-4678-a29f-de28c813ea65/artifacts/nv7abkas_masky%20logo.png";

const passportFeatures = [
  { icon: BookOpen, text: "Track their progress", color: "bg-[#0A1A2F]" },
  { icon: Star, text: "Collect stickers", color: "bg-[#D4A857]" },
  { icon: Trophy, text: "Celebrate new skills", color: "bg-[#3FA9F5]" },
  { icon: Lightbulb, text: "Follow Masky's tips & challenges", color: "bg-[#0A1A2F]" },
];

export default function PassportSection() {
  return (
    <section
      id="passport"
      className="py-20 bg-[#F4F4F4]"
      data-testid="passport-section"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-[#D4A857]/10 text-[#D4A857] px-4 py-2 rounded text-sm font-bold uppercase tracking-wide mb-4 font-['Montserrat']">
            <BookOpen size={16} />
            Every Child Gets One!
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0A1A2F] mb-4 font-['Montserrat']">
            The <span className="text-[#D4A857]">Masky Fencing Passport</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto font-['Lato']">
            Every child receives their own Masky Fencing Passport on their first day — 
            making every session feel like an adventure!
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Passport Visual */}
          <div className="relative">
            <div className="bg-white rounded-lg shadow-2xl p-8 border-4 border-[#D4A857]/20">
              {/* Passport Header */}
              <div className="bg-[#0A1A2F] rounded-lg p-4 mb-6 flex items-center gap-4">
                <img
                  src="https://customer-assets.emergentagent.com/job_1abea0ec-cded-4678-a29f-de28c813ea65/artifacts/2pfnnew9_bigger%20masky.png"
                  alt="Masky"
                  className="w-20 h-20 object-contain masky-glow-sm"
                />
                <div className="text-white">
                  <img src={MASKY_LOGO} alt="MASKY" className="h-8 mb-1 masky-glow-sm" />
                  <p className="text-white/70 text-sm font-['Lato']">Fencing Passport — Your Adventure Awaits!</p>
                </div>
              </div>
              
              {/* Passport Content */}
              <div className="space-y-4">
                <div className="bg-[#F4F4F4] rounded-lg p-4">
                  <p className="text-sm font-bold text-[#0A1A2F] mb-2 font-['Montserrat']">Fencer's Name:</p>
                  <div className="h-8 bg-white rounded border-2 border-dashed border-[#D4A857]/30"></div>
                </div>
                
                <div className="grid grid-cols-5 gap-2">
                  {[1, 2, 3, 4, 5].map((day) => (
                    <div key={day} className="text-center">
                      <div className="w-12 h-12 mx-auto bg-white rounded-full border-2 border-dashed border-gray-300 flex items-center justify-center mb-1">
                        <Star className="w-5 h-5 text-gray-300" />
                      </div>
                      <p className="text-xs text-gray-500 font-['Lato']">Day {day}</p>
                    </div>
                  ))}
                </div>
                
                <div className="bg-[#D4A857]/10 rounded-lg p-3 text-center">
                  <p className="text-sm text-[#0A1A2F] font-medium font-['Lato']">
                    "Collect stickers • Track progress • Level up!"
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Features */}
          <div className="space-y-6">
            <p className="text-lg text-gray-600 leading-relaxed font-['Lato']">
              It's a fun, colourful booklet where your child can track their fencing journey. 
              <span className="font-bold text-[#0A1A2F]"> Masky is with them every step of the way!</span>
            </p>

            <div className="space-y-4">
              {passportFeatures.map((feature, i) => (
                <div
                  key={i}
                  className="flex items-center gap-4 bg-white rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow border border-[#F4F4F4]"
                  data-testid={`passport-feature-${i}`}
                >
                  <div className={`${feature.color} w-12 h-12 rounded-lg flex items-center justify-center text-white`}>
                    <feature.icon size={24} />
                  </div>
                  <p className="font-semibold text-[#0A1A2F] font-['Montserrat']">{feature.text}</p>
                </div>
              ))}
            </div>

            {/* Masky Quote */}
            <div className="bg-[#0A1A2F] rounded-lg p-5 text-white relative overflow-hidden">
              <p className="font-bold text-[#D4A857] mb-2 font-['Montserrat'] uppercase text-sm">Masky says:</p>
              <p className="text-white/90 italic font-['Lato']">
                "Your passport is your adventure log! Every sticker is a step closer to becoming 
                a brilliant fencer. I can't wait to celebrate with you!"
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
